var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FieldSelect } from '@dixa/lib-shared-habla';
import { useCallback, useEffect, useMemo } from 'react';
import { withQueues } from 'hocs';
function QueuePickerImpl(_a) {
    var { queues, selectedQueue, input } = _a, otherProps = __rest(_a, ["queues", "selectedQueue", "input"]);
    const { items: queueItems, searchTermChange, getItemsAsyncStatus, getItems, hasNextPage, hasPreviousPage, nextPage, previousPage, } = queues;
    /*
     * Because the queues are paginated the select component won't be able to display
     * the initial value unless it's in the first page.
     *
     * This is why we're adding the 'selectedQueue' as an item if it's not in the list.
     */
    const items = useMemo(() => {
        const isSelectedQueueLoaded = selectedQueue && queueItems.some(({ id }) => id === selectedQueue.value);
        if (!selectedQueue || isSelectedQueueLoaded) {
            return queueItems;
        }
        return [
            ...queueItems,
            {
                id: selectedQueue.value,
                name: selectedQueue.label,
            },
        ];
    }, [selectedQueue, queueItems]);
    const onChange = useCallback((queueId) => {
        const { onChange } = input;
        const queue = items.find(({ id }) => id === queueId);
        onChange === null || onChange === void 0 ? void 0 : onChange(queue);
    }, [input, items]);
    const onToggle = useCallback((isOpen) => {
        isOpen && searchTermChange('');
    }, [searchTermChange]);
    useEffect(() => {
        getItems();
    }, [getItems]);
    const selectedItem = selectedQueue ? [selectedQueue.value] : [];
    const isLoading = getItemsAsyncStatus === 'loading';
    return (_jsx(FieldSelect, Object.assign({ items: items, loading: isLoading, onSearch: searchTermChange, onToggle: onToggle, selectedItems: selectedItem, pagination: {
            infinite: true,
            nextEnable: hasNextPage,
            previousEnable: hasPreviousPage,
            onNext: nextPage,
            onPrevious: previousPage,
        }, input: Object.assign(Object.assign({}, input), { value: (selectedQueue === null || selectedQueue === void 0 ? void 0 : selectedQueue.value) || '', onChange }), searchable: true }, otherProps)));
}
export const QueuePicker = withQueues(QueuePickerImpl, { infinite: true });
